// const markers = [
//   'intro',
//   'loop_start',
//   'loop_end',
// ] as const;

const lottieId = [
  'icon-rising-sun',
  'icon-petal',
  'icon-pinwheel',
  'icon-wave',
  'icon-moon',
  'icon-fan',
  'icon-enso',
  'icon-bonsai',
  'icon-rising-sun-open',
  'icon-rising-sun-full-markers',
  'loader-dc',
  'modern-creativity',
  'invents-the-future',
  'changes-society',
  'creates-culture',
  'services-01',
  'services-02',
  'services-03',
  'services-04',
  'services-05',
  'services-full',
  'services-full-looping',
] as const;

export type LottieId = (typeof lottieId)[number];

export const lottieConfig: Record<LottieId, { path: string }> = {
  'invents-the-future': {
    path: '/lottie/invents-the-future.json',
  },
  'changes-society': {
    path: '/lottie/changes-society.json',
  },
  'creates-culture': {
    path: '/lottie/creates-culture.json',
  },
  'modern-creativity': {
    path: '/lottie/modern-creativity.json',
  },
  'loader-dc': {
    path: '/lottie/loader-dc.json',
  },
  'icon-rising-sun-full-markers': {
    path: '/lottie/icon-rising-sun-full-markers.json',
  },
  'icon-rising-sun-open': {
    path: '/lottie/icon-rising-sun-open.json',
  },
  'icon-petal': {
    path: '/lottie/icon-drop.json',
  },
  'icon-wave': {
    path: '/lottie/icon-scale.json',
  },
  'icon-pinwheel': {
    path: '/lottie/icon-pinwheel.json',
  },
  'icon-moon': {
    path: '/lottie/icon-moon.json',
  },
  'icon-fan': {
    path: '/lottie/icon-fan.json',
  },
  'icon-enso': {
    path: '/lottie/icon-enso.json',
  },
  'icon-bonsai': {
    path: '/lottie/icon-bonsai.json',
  },
  'icon-rising-sun': {
    path: '/lottie/icon-rising-sun.json',
  },
  'services-01': {
    path: '/lottie/services-shapes/01.json',
  },
  'services-02': {
    path: '/lottie/services-shapes/02.json',
  },
  'services-03': {
    path: '/lottie/services-shapes/03.json',
  },
  'services-04': {
    path: '/lottie/services-shapes/04.json',
  },
  'services-05': {
    path: '/lottie/services-shapes/05.json',
  },
  'services-full': {
    path: '/lottie/services-shapes/full.json',
  },
  'services-full-looping': {
    path: '/lottie/services-shapes/full-looping.json',
  },
};
